"use strict";

var LoggerInstance = require("js-logger").get("NavigationActions");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var NavigationStore = require("../stores/NavigationStore");

var deviceWidths = Constants.DEVICE_MIN_WIDTHS;

var NavigationActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.NAVIGATION_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	toggleSelected: function (event) {
		var handledEvent = false;

		try {
			if (!event || !event.target) {
				return;
			}

			var $target = $(event.target);
			var componentName = $target.attr("data-component");
			var isDesignMode = NavigationStore.get("isDesignMode");
			var isPrimaryNavigation = $target.parents("[data-component='primaryNavigation']").length > 0;
			var unselect = ($selectedElements) => {
				if (!$selectedElements || $selectedElements.length <= 0) {
					return;
				}

				$selectedElements.each((index, element) => {
					var $navigationItem = $(element).closest("[data-component='navigationItem']");

					if ($navigationItem[0] !== $target[0] && $navigationItem.find($target).length <= 0) {
						$navigationItem.find(".selected").addBack().removeClass("selected");
						$navigationItem.find("ul.expanded").addBack("ul").removeClass("expanded");
					}
				});
			};

			/*
				We never want the mouseover/out logic to run in the LD and SG as it should only be executed on published layouts.
				The LD & SG should always use the click logic. This is also reflected in navigation CSS in site.css
			*/
			switch (event.type) {
				case "mouseover":
					if (!isDesignMode && isPrimaryNavigation && window.innerWidth >= deviceWidths.DESKTOP) {
						unselect($("nav .selected"));
						if (componentName === "navigationItem") {
							$target.addClass("selected");
						} else if (componentName === "navigationItem.label" || componentName === "navigationItem.menu") {
							$target.addClass("selected");
							$target.parents("[data-component='navigationItem']").first().addClass("selected");
							if (componentName === "navigationItem.label") {
								$target.parents("[data-component='navigationItem.menu']").first().addClass("selected");
							}
						}
						handledEvent = true;
					}
					break;
				case "mouseout":
					if (!isDesignMode && isPrimaryNavigation && window.innerWidth >= deviceWidths.DESKTOP) {
						$target.removeClass("selected");
						handledEvent = true;
					}
					break;
				case "click":
					var $navigationItem;

					if (isDesignMode && (!event.ctrlKey && !event.metaKey)) {
						return;
					}

					if (isDesignMode || !isPrimaryNavigation || window.innerWidth < deviceWidths.DESKTOP) {
						handledEvent = true;
						if (isPrimaryNavigation) {
							unselect($("nav .selected, nav ul.expanded"));
						} else {
							unselect($("div[role='navigation'] .selected, div[role='navigation'] ul.expanded"));
						}

						if (componentName === "primaryNavigation.label") {
							$target.siblings("ul").first().toggleClass("expanded");
						} else if (componentName === "navigationItem") {
							$target.toggleClass("selected");
							$target.children("ul").first().toggleClass("expanded");
						} else if (componentName === "navigationItem.label" || componentName === "navigationItem.menu") {
							$navigationItem = $target.parents("[data-component='navigationItem']").first();
							$target.toggleClass("selected");
							$navigationItem.toggleClass("selected");
							$navigationItem.children("ul").first().toggleClass("expanded");
							if (componentName === "navigationItem.label") {
								$target.parents("[data-component='navigationItem.menu']").first().toggleClass("selected");
							}
						} else if (!componentName && $target[0].tagName === "A") {
							$target.parent("[data-component='navigationItem.label']").toggleClass("selected");
							$target.parents("[data-component='navigationItem.menu']").first().toggleClass("selected");
							$navigationItem = $target.parents("[data-component='navigationItem']").first();
							$navigationItem.toggleClass("selected");
							$navigationItem.children("ul").first().toggleClass("expanded");
						}

						if (!isDesignMode) {
							// We still want the event to perform its default action, just not propagate the action up the DOM
							handledEvent = false;
							event.stopPropagation();
						}
					}
					break;
				default:
					break;
			}
		}
		catch(exception) {
			LoggerInstance.error(exception);
		}
		finally {
			if (handledEvent) {
				// Legacy preventDefault
				return false;
			}
			return true;
		}
	},

	toggleHamburger: function (event) {
		if (!event || !event.target || (NavigationStore.get("isDesignMode") && !event.ctrlKey && !event.metaKey)) {
			return;
		}

		$(event.target).closest("[data-component='primaryNavigation.mobile']").toggleClass("expanded");
		return this.toggleSelected(event);
	},

	noMobileLink: function (event) {
		if (!event || event.type !== "click" || (NavigationStore.get("isDesignMode") && !event.ctrlKey && !event.metaKey)) {
			return;
		}

		if (window.innerWidth < deviceWidths.DESKTOP) {
			event.preventDefault();
		}
	}

};

module.exports = NavigationActions;


// WEBPACK FOOTER //
// ./Javascript/actions/NavigationActions.jsx